import React from 'react'
// import { useStaticQuery, graphql } from 'gatsby'
import { GatsbyImage } from "gatsby-plugin-image";

import { ResponsiveContainer } from './../../components/ResponsiveContainer/ResponsiveContainer'

import InstagramSVG from './../../images/svgs/instagram.svg';
import ExternalSVG from './../../images/svgs/external.svg';
import * as s from './Instagram.module.scss'

import instaPost1 from './../../images/insta_posts/new_01.webp';
import instaPost2 from './../../images/insta_posts/new_02.webp';
import instaPost3 from './../../images/insta_posts/new_03.webp';

export const Instagram = () => {
    const data = [
      instaPost1,
      instaPost2,
      instaPost3
    ]; // useStaticQuery(instagramQuery);

    /* const instaImages = data.allInstaNode.edges.map((instaImage, index) => {
      return (
        <div key={index} className={s.img}>
            <ResponsiveContainer aspectRatio="1:1">
                <GatsbyImage
                  image={instaImage?.node?.localFile?.childImageSharp?.gatsbyImageData}
                  style={{ position: 'absolute' }} 
                  alt=""
                  />
            </ResponsiveContainer>
        </div>
      );
    }); */

    const instaImages = data.map((instaImage, index) => {
      return (
        <div key={index} className={s.img}>
            <ResponsiveContainer aspectRatio="1:1">
                {/* <GatsbyImage
                  image={instaImage}
                  style={{ position: 'absolute' }} 
                  alt=""
                  /> */}
                <img src={instaImage} alt="" style={{position:'absolute'}} />
            </ResponsiveContainer>
        </div>
      );
    });

    return (
        <div className={s.wrapper}>
            <div className={`container ${s.inner}`}>
                <div className={s.text}>
                  <p className="h2">
                      <span className="font-serif">Want to see more? </span><br/>
                      Follow us on the ol’ gram!
                  </p>
                  <a className={s.link} href="https://www.instagram.com/collectivehaus/" target="_blank" rel="noreferrer"><InstagramSVG /> @collectivehaus <span className="sr-only">on Instagram</span> <ExternalSVG /></a>
                </div>
                <div className={s.imgWrapper}>
                  <div className={s.innerImgWrapper}>
                    <div className={s.innerImgGrid}>
                      {instaImages}
                    </div>
                  </div>
                </div>
            </div>
        </div>
    );
}

// DEPRECATED: allInstaNode no longer works and an API Access Key is now required in order to fetch Insta posts
/* const instagramQuery = graphql`{
  allInstaNode(limit: 3, sort: {fields: timestamp, order: DESC}) {
    edges {
      node {
        localFile {
          childImageSharp {
            id
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
      }
    }
  }
}
` */